import { formatAccountingPeriod } from "@utils/formatAccountingPeriod";

export const getAccountingPeriodOptions = (
  accountingPeriods: {
    id: string;
    periodStart: string;
    periodEnd: string;
  }[],
  formatPeriod: (period: {
    periodStart: string;
    periodEnd: string;
  }) => string = formatAccountingPeriod,
) => {
  return accountingPeriods?.map(y => ({
    label: formatPeriod({
      periodStart: y.periodStart,
      periodEnd: y.periodEnd,
    }),
    value: y,
  }));
};
